module.exports = __webpack_public_path__ + "images/mobile/init/bg-event-f2e9dd65a55bd9660ceface4a72d5756.png";